import {
  Card,
  Input,
  Button,
  DateInputOnChangeEvent,
  MultiselectChangeEvent,
  StructuredOption,
  SingleSelect,
  DateInput,
} from "@/vendor/Forge/dist";
import { styled } from "@stitches/react";
import SearchIcon from "@/components/Icons/search";
import { PlusButtonSmall as PlusButton } from "@/vendor/forge-icons/dist";
import { MinusButtonSmall as MinusButton } from "@/vendor/forge-icons/dist";
import { useEffect, useState } from "react";
import { useUsers } from "@/hooks/use-users";
import { useAppState } from "@/contexts/app-state";
import { useMetricsContext } from "@/contexts/metrics-context";
import { Banner } from "@/vendor/Forge/dist";
import { BannerItem } from "@/vendor/Forge/dist";
import { useDebounce } from "@/hooks/use-debounce";
import { useFiltersWithSearchString } from "@/hooks/use-filters-search-string";
import Loader from "@components/Loader";
import { filterCap } from "@/utils/helpers";

const Wrapper = styled("div", {
  height: "100%",
  width: "500px",

  "& .fe_c_heading": {
    fontWeight: "700",
    fontSize: "16px",
  },
  "& .fe_c_date-input__input": {
    width: "100%",
  },
  "& .react-datepicker__input-container": {
    display: "flex",
    flexFlow: "nowrap",
  },
  "& .dateLabel": {
    color: "#5D5E5E",
    fontWeight: "400",
    fontSize: "14px",
    marginBottom: "-2px",
  },
  "& .bucketLabel": {
    color: "#5D5E5E",
    fontWeight: "400",
    fontSize: "14px",
    marginBottom: "5px",
    marginLeft: "20px",
  },
  "& .multiSelectLabel": {
    color: "#5D5E5E",
    fontWeight: "400",
    fontSize: "14px",
    marginBottom: "5px",
    marginTop: "15px",
  },
  "& .fe_c_multiselect": {
    width: "149px",
  },
});

const CardComponent = styled(Card, {
  height: "100%",
  width: "500px",

  "& .fe_c_card__content--padded ": {
    padding: "15px",
  },
});

const CardContentWrapper = styled("div", {
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
});

const FiltersContainer = styled("div", {
  display: "flex",
  flexDirection: "column",
});

const SearchFieldWrapper = styled("div", {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  gap: "5px",
  width: "224px",

  "& svg": {
    position: "absolute",
    top: 8,
    left: 8,
  },
  "& p": {
    marginBottom: "0px",
    fontWeight: "700",
  },
  "& .fe_c_input": {
    width: "120px",
  },
});

const DateRangeWrapper = styled("div", {
  display: "flex",
  alignItems: "center",
  width: "265px",

  "& p": {
    marginLeft: "10px",
    marginRight: "10px",
    paddingTop: "12px",
  },
  "& .fe_c_date-input": {
    height: "32px",
  },
});

const TagsSelect = styled("div", {
  display: "flex",
  flexDirection: "column",
  gap: 8,
  marginTop: "5px",
  height: "170px",
  overflowY: "auto",
  backgroundColor: "white",
  padding: "5px",
  width: "224px",

  "& p": {
    fontSize: "16px",
  },
});

const TagsDeselect = styled("div", {
  display: "flex",
  flexDirection: "column",
  gap: 8,
  marginTop: "5px",
  height: "170px",
  overflowY: "auto",
  backgroundColor: "#EDEDFB",
  padding: "5px",
  width: "224px",

  "& p": {
    fontSize: "16px",
  },
});

const TagsContainer = styled("div", {
  display: "flex",
  flexDirection: "column",
  width: "224px",
});

const TagsWrapper = styled("div", {
  display: "flex",
  justifyContent: "space-between",
});

const SelectListItem = styled("div", {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  borderBottom: "solid #AFAFAF",

  "& p": {
    marginBottom: "0px",
  },
});

const FiltersWarningWrapper = styled("div", {
  marginTop: "10px",

  "& .fe_c_banner": {
    backgroundColor: "#FDF9ED",
    borderLeft: 0,
    height: "28px",
    boxShadow: "none",
    gap: "5px",
    padding: "0px",
    paddingLeft: "6px",
    display: "flex",
    alignItems: "center",
  },
  "& p": {
    marginBottom: "0px",
    color: "#5D5E5E",
    fontSize: "14px",
  },
  "& svg": {
    height: "16px",
    width: "16px",
  },
  "& span": {
    fontWeight: "700",
  },
});

const DynamicFieldsWrapper = styled("div", {
  display: "flex",
  alignItems: "center",

  "& .fe_c_date-input__input": {
    width: "120px",
  },
  "& .fe_c_multiselect": {
    width: "149px",
    height: "32px",
    marginLeft: "20px",
  },
});

const DateRangeContainer = styled("div", {
  display: "flex",
  flexFlow: "column",
});

const BucketContainer = styled("div", {
  display: "flex",
  flexFlow: "column",
  height: "64px",
});

const isDateRangeOverYear = (d1: Date, d2: Date) => {
  const d1Formatted = d1.getTime();
  const d2Formatted = d2.getTime();
  const dateDiff = Math.abs(d1Formatted - d2Formatted);
  const diffDays = Math.floor(dateDiff / (1000 * 60 * 60 * 24) + 1);
  const yearBoolean = diffDays >= 365;

  return yearBoolean;
};

const FiltersTableMetrics = () => {
  const { currentUser, updateAppState } = useAppState();
  const { filters, updateFilters } = useMetricsContext();
  const [selectedOrderTypes, setSelectedOrderTypes] = useState<string[]>([]);
  const [selectedCarriers, setSelectedCarriers] = useState<string[]>([]);
  const [bucket, setBucket] = useState<string>(currentUser);
  const [searchOrderInput, setSearchOrderInput] = useState<string>("");
  const [searchCarrierInput, setSearchCarrierInput] = useState<string>("");
  const [filteredOrders, setFilteredOrders] = useState<string[]>([]);
  const [filteredCarriers, setFilteredCarriers] = useState<string[]>([]);
  const [displayCarriersFilterWarning, setDisplayCarriersFilterWarning] =
    useState(false);
  const [displayOrderTypesFilterWarning, setDisplayOrderTypesFilterWarning] =
    useState(false);
  const [dateRangeStart, setDateRangeStart] = useState<Date>();
  const [dateRangeEnd, setDateRangeEnd] = useState<Date>();
  const [dateError, setDateError] = useState<boolean>(false);
  const [carriersLimitWarning, setCarriersLimitWarning] = useState(false);
  const [orderTypesLimitWarning, setOrderTypesLimitWarning] = useState(false);
  const { data: users = [] } = useUsers();

  const orderDebouncedInput = useDebounce(searchOrderInput, 900);
  const {
    data: orderTypes,
    isError: isOrderTypesError,
    error: orderTypesError,
    isFetching: isOrderTypesFetching,
    isFetched: isOrderTypesFetched,
  } = useFiltersWithSearchString("orderName", orderDebouncedInput);
  const carrierDebouncedInput = useDebounce(searchCarrierInput, 900);
  const {
    data: carriers,
    isError: isCarrierError,
    error: carriersError,
    isFetching: isCarriesFetching,
    isFetched: isCarriersFetched,
  } = useFiltersWithSearchString("insurance", carrierDebouncedInput);

  useEffect(() => {
    setBucket(currentUser);
    setSelectedOrderTypes([...(filters.orderNames || [])]);
    setSelectedCarriers([...(filters.insurances || [])]);
  }, [currentUser, filters]);

  useEffect(() => {
    setDisplayOrderTypesFilterWarning(false);
    setOrderTypesLimitWarning(false);

    if (selectedOrderTypes.length != filters?.orderNames?.length) {
      setDisplayOrderTypesFilterWarning(true);
    }
    if (selectedOrderTypes.length > filterCap) {
      setOrderTypesLimitWarning(true);
    }
  }, [selectedOrderTypes, filters]);

  useEffect(() => {
    setDisplayCarriersFilterWarning(false);
    setCarriersLimitWarning(false);
    if (selectedCarriers.length != filters?.insurances?.length) {
      setDisplayCarriersFilterWarning(true);
    }
    if (selectedCarriers.length > filterCap) {
      setCarriersLimitWarning(true);
    }
  }, [selectedCarriers, filters]);

  useEffect(() => {
    if (filters.performDateRangeEnd && filters.performDateRangeStart) {
      setDateRangeStart(new Date(filters.performDateRangeStart));
      setDateRangeEnd(new Date(filters.performDateRangeEnd));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (dateRangeStart && dateRangeEnd) {
      if (isDateRangeOverYear(dateRangeStart, dateRangeEnd)) {
        setDateError(true);
      } else {
        setDateError(false);
        updateFilters({
          performDateRangeStart: dateRangeStart.toLocaleDateString("en-US", {
            month: "2-digit",
            day: "2-digit",
            year: "numeric",
          }),
          performDateRangeEnd: dateRangeEnd.toLocaleDateString("en-US", {
            month: "2-digit",
            day: "2-digit",
            year: "numeric",
          }),
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dateRangeStart, dateRangeEnd]);

  const addSelectedOrderType = (orderType: string) => {
    setSelectedOrderTypes((prev) => [...prev, orderType]);
  };

  const clearSelectedOrderTypes = () => {
    setSelectedOrderTypes([]);
  };

  const deselectOrderType = (orderType: string) => {
    setSelectedOrderTypes((prev) => {
      return prev.filter((order) => order !== orderType);
    });
  };
  const selectAllFilteredCarriers = () => {
    setSelectedCarriers((prev) => [...prev, ...filteredCarriers]);
  };

  const selectAllCarriers = () => {
    if (carriers && carriers.length > 0) {
      setSelectedCarriers(carriers);
    }
  };

  const addSelectedCarrier = (carrier: string) => {
    setSelectedCarriers((prev) => [...prev, carrier]);
  };

  const clearSelectedCarriers = () => {
    setSelectedCarriers([]);
  };

  useEffect(() => {
    setFilteredOrders([]);
  }, [searchOrderInput]);

  useEffect(() => {
    setFilteredCarriers([]);
  }, [searchCarrierInput]);

  useEffect(() => {
    if (orderTypes && orderTypes.length > 0) {
      setFilteredOrders(
        orderTypes.filter(
          (orderType) => !selectedOrderTypes.includes(orderType),
        ),
      );
    }
  }, [orderTypes, selectedOrderTypes]);

  useEffect(() => {
    if (carriers && carriers.length > 0) {
      setFilteredCarriers(
        carriers.filter((carrier) => !selectedCarriers.includes(carrier)),
      );
    }
  }, [carriers, selectedCarriers]);

  const searchOrderItems = (searchValue: string) => {
    setSearchOrderInput(searchValue);
  };
  const searchCarrierItems = (searchValue: string) => {
    setSearchCarrierInput(searchValue);
  };

  const deselectCarrier = (selectedCarrier: string) => {
    setSelectedCarriers((prev) => {
      return prev.filter((carrier) => carrier !== selectedCarrier);
    });
  };
  const selectAllFilteredOrderTypes = () => {
    setSelectedOrderTypes((prev) => [...prev, ...filteredOrders]);
  };
  const selectAllOrderTypes = () => {
    if (orderTypes && orderTypes.length > 0) {
      setSelectedOrderTypes(orderTypes);
    }
  };

  const handleSubmit = () => {
    setDisplayCarriersFilterWarning(false);
    setDisplayOrderTypesFilterWarning(false);
    updateFilters({
      orderNames: selectedOrderTypes,
      insurances: selectedCarriers,
    });
  };
  const warningOrderMessage = `Please limit your selection to 500 or fewer Order Types`;
  const warningCarrierMessage = `Please limit your selection to 500 or fewer Carriers`;
  return (
    <Wrapper>
      <CardComponent
        headingText="Filter Orders"
        style={{ background: "#F3F3F3" }}
      >
        <CardContentWrapper>
          <FiltersContainer id="filter-container">
            <DynamicFieldsWrapper>
              <DateRangeContainer>
                <p className="dateLabel">Perform Date</p>
                <DateRangeWrapper>
                  <DateInput
                    placeholder={filters.performDateRangeStart?.replace(
                      /\//g,
                      "-",
                    )}
                    value={dateRangeStart}
                    onChange={(e: DateInputOnChangeEvent) =>
                      setDateRangeStart(e.target.value ?? undefined)
                    }
                  />
                  <p>-</p>
                  <DateInput
                    placeholder={filters.performDateRangeEnd?.replace(
                      /\//g,
                      "-",
                    )}
                    value={dateRangeEnd}
                    onChange={(e: DateInputOnChangeEvent) =>
                      setDateRangeEnd(e.target.value ?? undefined)
                    }
                  />
                </DateRangeWrapper>
              </DateRangeContainer>
              <BucketContainer>
                <p className="bucketLabel">Bucket</p>
                <SingleSelect
                  inputId="current-bucket-select"
                  value={bucket}
                  options={users}
                  onChange={(
                    e: MultiselectChangeEvent<StructuredOption, false>,
                  ) => {
                    const selected = e.target.value;
                    return updateAppState({
                      currentUser: selected?.value,
                    });
                  }}
                />
              </BucketContainer>
            </DynamicFieldsWrapper>
            {dateError ? (
              <Banner alertType="critical">
                <BannerItem headerText="Date Range Cannot Exceed A Year." />
              </Banner>
            ) : (
              <></>
            )}
            <p className="multiSelectLabel">Order Type</p>
            <TagsWrapper>
              <TagsContainer>
                <SearchFieldWrapper>
                  <Input
                    id="searchOrders"
                    icon={SearchIcon}
                    placeholder="Search"
                    onChange={(e) => searchOrderItems(e.target.value)}
                  />
                  <Loader
                    isLoading={
                      isOrderTypesFetching && isOrderTypesFetched
                    }
                    displayText="Checking Available Filter Options"
                    isError={isOrderTypesError}
                    errorReason={orderTypesError?.message}
                  >
                    {searchOrderInput.length > 1 ? (
                      <Button
                        variant="tertiary"
                        onClick={selectAllFilteredOrderTypes}
                      >
                        Select All
                      </Button>
                    ) : (
                      <Button variant="tertiary" onClick={selectAllOrderTypes}>
                        Select All
                      </Button>
                    )}
                  </Loader>
                </SearchFieldWrapper>
                <TagsSelect>
                  {searchOrderInput.length > 1 &&
                    filteredOrders.map((orderType: string, index: number) => (
                      <SelectListItem key={index}>
                        <p>{orderType}</p>
                        <Button
                          variant="tertiary"
                          onClick={() => addSelectedOrderType(orderType)}
                        >
                          <PlusButton />
                        </Button>
                      </SelectListItem>
                    ))}
                </TagsSelect>
              </TagsContainer>
              <TagsContainer>
                <SearchFieldWrapper>
                  <p>Selected</p>
                  <Button onClick={clearSelectedOrderTypes} variant="tertiary">
                    Clear All
                  </Button>
                </SearchFieldWrapper>
                <TagsDeselect>
                  {selectedOrderTypes.map((orderType, index) => (
                    <SelectListItem key={index}>
                      <p>{orderType}</p>
                      <Button
                        variant="tertiary"
                        onClick={() => deselectOrderType(orderType)}
                      >
                        <MinusButton />
                      </Button>
                    </SelectListItem>
                  ))}
                </TagsDeselect>
              </TagsContainer>
            </TagsWrapper>
            {orderTypesLimitWarning ? (
              <FiltersWarningWrapper>
                <Banner alertType="attention">
                  <BannerItem>
                    <p>{warningOrderMessage}</p>
                  </BannerItem>
                </Banner>
              </FiltersWarningWrapper>
            ) : displayOrderTypesFilterWarning ? (
              <FiltersWarningWrapper>
                <Banner alertType="attention">
                  <BannerItem>
                    <p>
                      Your updated filters have not been applied.{" "}
                      <span>Click Apply</span> to refresh.
                    </p>
                  </BannerItem>
                </Banner>
              </FiltersWarningWrapper>
            ) : (
              <></>
            )}
            <p className="multiSelectLabel">Carrier</p>
            <TagsWrapper>
              <TagsContainer>
                <SearchFieldWrapper>
                  <Input
                    id="searchCarriers"
                    icon={SearchIcon}
                    placeholder="Search"
                    onChange={(e) => searchCarrierItems(e.target.value)}
                  />
                  <Loader
                    isLoading={
                      isCarriesFetching && isCarriersFetched
                    }
                    displayText="Checking Available Filter Options"
                    isError={isCarrierError}
                    errorReason={carriersError?.message}
                  >
                    {searchCarrierInput.length > 1 ? (
                      <Button
                        variant="tertiary"
                        onClick={selectAllFilteredCarriers}
                      >
                        Select All
                      </Button>
                    ) : (
                      <Button variant="tertiary" onClick={selectAllCarriers}>
                        Select All
                      </Button>
                    )}
                  </Loader>
                </SearchFieldWrapper>
                <TagsSelect>
                  {searchCarrierInput.length > 1 &&
                    filteredCarriers.map((carrier, index) => (
                      <SelectListItem key={index}>
                        <p>{carrier}</p>
                        <Button
                          variant="tertiary"
                          onClick={() => addSelectedCarrier(carrier)}
                        >
                          <PlusButton />
                        </Button>
                      </SelectListItem>
                    ))}
                </TagsSelect>
              </TagsContainer>
              <TagsContainer>
                <SearchFieldWrapper>
                  <p>Selected</p>
                  <Button onClick={clearSelectedCarriers} variant="tertiary">
                    Clear All
                  </Button>
                </SearchFieldWrapper>
                <TagsDeselect>
                  {selectedCarriers.map((carrier) => (
                    <SelectListItem key={carrier}>
                      <p>{carrier}</p>
                      <Button
                        variant="tertiary"
                        onClick={() => deselectCarrier(carrier)}
                      >
                        <MinusButton />
                      </Button>
                    </SelectListItem>
                  ))}
                </TagsDeselect>
              </TagsContainer>
            </TagsWrapper>
            {carriersLimitWarning ? (
              <FiltersWarningWrapper>
                <Banner alertType="attention">
                  <BannerItem>
                    <p>{warningCarrierMessage}</p>
                  </BannerItem>
                </Banner>
              </FiltersWarningWrapper>
            ) : displayCarriersFilterWarning ? (
              <FiltersWarningWrapper>
                <Banner alertType="attention">
                  <BannerItem>
                    <p>
                      Your updated filters have not been applied.{" "}
                      <span>Click Apply</span> to refresh.
                    </p>
                  </BannerItem>
                </Banner>
              </FiltersWarningWrapper>
            ) : (
              <></>
            )}
          </FiltersContainer>
          <Button
            onClick={handleSubmit}
            style={{ marginTop: "25px", height: "56px" }}
          >
            Apply
          </Button>
        </CardContentWrapper>
      </CardComponent>
    </Wrapper>
  );
};

export default FiltersTableMetrics;
